import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useMemo } from "react";
import { useUsersRetrieve, getUsersRetrieveQueryKey } from "../api-client/users/users";
import { STALE_TIME } from "../utils/constants.ts";

export const useUserQuery = () => {
  //const state = localStorage.getItem("state");
  const storedUser = localStorage.getItem("user");

  // Only fetch if user is logged in (has state or user in localStorage)
  const enabled = true; //!!(state || storedUser);

  const query = useUsersRetrieve(0, {
    query: {
      enabled,
      staleTime: STALE_TIME, // 5 minutes
      retry: false,
    },
  });

  // Sync with localStorage
  useEffect(() => {
    if (query.error) {
      localStorage.removeItem("user");
      localStorage.removeItem("state");
    } else if (query.data && !query.isLoading) {
      localStorage.setItem("user", JSON.stringify(query.data));
      localStorage.setItem("state", "news");
    }
  }, [query.data, query.error, query.isLoading]);

  const cachedUser = useMemo(() => {
    if (!storedUser) return undefined;
    try {
      return JSON.parse(storedUser);
    } catch {
      return undefined;
    }
  }, [storedUser]);

  // Use query data if available, otherwise fall back to cached localStorage
  const userData = query.data || cachedUser;

  return {
    ...query,
    data: userData,
    user: userData,
  };
};

// Helper to invalidate user queries
const invalidateUser = (queryClient: ReturnType<typeof useQueryClient>) => {
  return queryClient.invalidateQueries({
    queryKey: getUsersRetrieveQueryKey(0),
  });
};

// Export for backward compatibility with old mutateUser pattern
export const mutateUser = async () => {
  const { queryClient } = await import("../lib/queryClient");
  return invalidateUser(queryClient);
};
